import React, { useState, useEffect } from "react";
import { Menu, Dropdown, Avatar, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { SettingOutlined, QuestionCircleOutlined, LogoutOutlined, TeamOutlined, TrophyOutlined } from "@ant-design/icons";
import Icon from "components/util-components/Icon";
import IntlMessage from "../util-components/IntlMessage";
import { getSelfProfileImage } from "../util-components/Auth";
import VerifiedAccount from "../util-components/VerifiedAccount";
import { getAuth0LogoutOptions } from "../util-components/Auth0/auth0Helpers";
import moment from "moment-timezone";

const menuItem = [
  {
    title: <IntlMessage id={"navigator.profile.account_settings"} />,
    icon: SettingOutlined,
    path: "/account",
  },

  {
    title: <IntlMessage id={"navigator.profile.team_management"} />,
    icon: TeamOutlined,
    path: "/account/team-management",
  },
  {
    title: <IntlMessage id={"navigator.profile.achievements"} />,
    icon: TrophyOutlined,
    path: "/achievements",
  },
  {
    title: "--separator--",
  },
  // {
  //   title: <IntlMessage id={"navigator.profile.billing"} />,
  //   icon: ShopOutlined,
  //   path: "/",
  // },
  {
    title: <IntlMessage id={"navigator.profile.help_center"} />,
    icon: QuestionCircleOutlined,
    external: true,
    path: "https://ajuda.salespark.io",
  },
  {
    title: "--separator--",
  },
];

const initChat = (auth, uniqueUserId) => {
  try {
    // var Tawk_API = window.Tawk_API || undefined;
    // if (Tawk_API === undefined) return;
    // Tawk_API.setAttributes(
    //   {
    //     user_type: "Producer",
    //     producer_id: auth?.user?.id || 999,
    //     name: auth?.user?.name,
    //     email: auth?.user?.email,
    //     hash: uniqueUserId,
    //   },
    //   function (error) {}
    // );
    if (!auth?.email) return;

    window.$chatwoot.setUser(auth?.email, {
      email: auth?.email,
      name: auth?.user?.name,
      avatar_url: auth?.picture,
      entity_type: "Producer",
      entity_id: auth?.user?.id,
    });

    // window.groove.widget.identifyContact("contact_email", auth?.email);
    // window.groove.widget.setContact(producerData);
  } catch (error) {
    //
  }
};

export const NavProfile = ({ auth, logout }) => {
  const [profileImage] = useState(getSelfProfileImage(auth, 40));
  const uniqueUserId = `appv2@${auth?.email}`;
  if (auth !== undefined) {
    if (auth !== undefined && window?.$chatwoot) {
      window.$chatwoot.setUser(auth?.email, {
        email: auth?.email,
        name: auth?.user?.name,
        avatar_url: auth?.picture,
        entity_type: "Producer",
        entity_id: auth?.user?.id,
      });

      // window.groove.widget.identifyContact("contact_email", auth?.email);
      // window.groove.widget.setContact(producerData);
    }
    // if (auth !== undefined && window.Tawk_API) {
    //   window.Tawk_API.onLoad = function () {
    //     window.Tawk_API.setAttributes(
    //       {
    //         name: auth?.user?.name,
    //         email: auth?.user?.email,
    //         hash: uniqueUserId,
    //       },
    //       function (error) {}
    //     );
    //   };
    //   window.Tawk_API.visitor = {
    //     name: auth?.user?.name,
    //     email: auth?.user?.email,
    //     hash: uniqueUserId,
    //   };
    // }
  }

  useEffect(() => {
    initChat(auth, uniqueUserId);
  }, []);

  if (auth === undefined) return <></>;
  const profileMenu = (
    <div className="nav-profile nav-dropdown">
      <div className="nav-profile-header">
        <div className="d-flex">
          <Avatar src={profileImage} />

          <div className="pl-3">
            <Link to={{ pathname: "/account/personal-data" }}>
              <div
                className="mb-0"
                style={{
                  fontWeight: 600,
                  width: "144px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <VerifiedAccount verified={auth?.verifiedAccount === true} />
                {auth?.user?.name}
              </div>
            </Link>
            <span className="text-muted">{"Administrador"}</span>
          </div>
        </div>
      </div>
      <div className="nav-profile-body">
        <Menu>
          {menuItem.map((el, i) => {
            if (el.title === "--separator--") {
              return <Menu.Divider key={i} />;
            }

            return el.external === true ? (
              <Menu.Item key={i}>
                <Link to={{ pathname: el.path }} target="_blank">
                  <Icon type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </Link>
              </Menu.Item>
            ) : (
              <Menu.Item key={i}>
                <Link to={el.path}>
                  <Icon type={el.icon} />
                  <span className="font-weight-normal">{el.title}</span>
                </Link>
              </Menu.Item>
            );
          })}
          <Menu.Item key={menuItem.length + 1} onClick={() => logout(getAuth0LogoutOptions())}>
            <span>
              <LogoutOutlined />
              <span className="font-weight-normal">
                <IntlMessage id={"navigator.profile.sign_out"} />
              </span>
            </span>
          </Menu.Item>
        </Menu>
      </div>
    </div>
  );

  const isXMAS = () => {
    let today = moment();
    let xmasStart = moment().month(11).date(1);
    let xmasEnd = moment().month(11).date(30);
    return today.isBetween(xmasStart, xmasEnd);
  };

  return (
    <Dropdown placement="bottomRight" overlay={profileMenu} trigger={["click"]}>
      <Menu className="d-flex align-item-center" mode="horizontal">
        <Menu.Item key="profile">
          <Tooltip title="Opções de Conta">
            <span className={isXMAS() === true ? "xmas_cap" : ""}>
              <Avatar src={profileImage} />
            </span>
          </Tooltip>
          {/* 
          Code causes multiple re-renders when Socket connection change (server restarts)
          {auth?.socketConnected && (
            <Tooltip title="Ligado ao serviço de notificações">
              <Badge dot color="green" style={{ top: -15, right: 10 }}></Badge>
            </Tooltip>
          )} 
          */}
        </Menu.Item>
      </Menu>
    </Dropdown>
  );
};

// export default connect(null, { signOut })(NavProfile);
export default React.memo(NavProfile);
